import { type SugarProgramYear } from '@app/types'

export const findProgramYearForDate = (
  programYears: SugarProgramYear[] | undefined,
  effectiveDate: string
): SugarProgramYear | null => {
  if (!effectiveDate || !programYears) return null

  return programYears.find((py) => effectiveDate >= py.startDate && effectiveDate <= py.endDate) ?? null
}

export const findProgramYearById = (
  programYears: SugarProgramYear[] | undefined,
  programYearId: string | null | undefined
): SugarProgramYear | null => {
  if (!programYearId || !programYears) return null

  return programYears.find((py) => py.id === programYearId) ?? null
}
